import React from "react";
import ReactDOM from "react-dom";
// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
// Put any other imports below so that CSS from your
// components takes precedence over default styles.

import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";
import { UserProvider } from "./Components/userFile";

ReactDOM.render(
  <Router>
    <UserProvider>
      <App />
    </UserProvider>
  </Router>,
  document.getElementById("root")
);
